import React, { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DevicesSortField } from 'enums';


interface IDevicesListSorterProps {
    activeField: DevicesSortField;
    ascending: boolean;
    className?: string;
    field: DevicesSortField;
    onToggle: (field: DevicesSortField) => void;
}

export const DevicesListSorter: FunctionComponent<IDevicesListSorterProps> = (props) => {
    let classNames = 'devicesHeaders_sorter';
    if (props.className) {
        classNames += ' ' + props.className;
    }

    return (
        <div className={classNames} onClick={() => props.onToggle(props.field)}>
            {props.children}
            {props.activeField === props.field && (
                props.ascending
                    ? <FontAwesomeIcon icon="caret-up" className="devicesHeaders_sortCaret" />
                    : <FontAwesomeIcon icon="caret-down" className="devicesHeaders_sortCaret" />
            )}
        </div>
    )
}